import Vue from 'vue'
import axios from 'axios'
export default {
    state:{
        getUrl(){
            const instance = axios.create({
                // baseURL: 'http://localhost:3000'
                // baseURL: 'http://10.2.210.211:30308'
                baseURL : Vue.config['url']
            });
            //instance.defaults.headers.common['Authorization'] = AUTH_TOKEN;
            instance.defaults.headers.common['x-auth-token'] = localStorage.getItem('token');
            instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
            return instance
        },
        // getUrl2(){
        //     const instance = axios.create({
        //         baseURL: 'http://localhost:3000'
        //         // baseURL: 'http://10.2.210.211:30308'
        //         // baseURL : process.env.VUE_APP_ROOT_API
        //     });
        //     //instance.defaults.headers.common['Authorization'] = AUTH_TOKEN;
        //     instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
        //     return instance
        // }
    },
    getAll(){
        return axios.get('/user')
            .then(function (response) {
                return Promise.resolve(response)
            })
            .catch(function (error) {
                return Promise.reject(error)
            });
    },
    // getAllStatusUser(){
    //     return this.state.getUrl().get('/user/get-all-status')
    //         .then(function (response) {
    //             return Promise.resolve(response.data)
    //         })
    //         .catch(function (error) {
    //             return Promise.reject(error.response.data.error)
    //         });
    // },
    getUserByStatus(status) {
        return axios.get('/user?status=' + status)
            .then(function(response) {
                return Promise.resolve(response);
            })
            .catch(function(error) {
                return Promise.reject(error);
            });
    },
    getInfo(id){
        return this.state.getUrl().get('/user/'+id)
            .then(function (response) {
                return Promise.resolve(response.data)
            })
            .catch(function (error) {
                return Promise.reject(error.response.data.error)
            });
    },
    saveUser(data){
        
        return axios.post('/user', data)
            .then(function (response) {
                // console.log("createCampaign then")
                return Promise.resolve(response)
            })
            .catch(function (error) {
                // console.log("createCampaign catch")
                return Promise.reject(error)
            });
    },
    updateUser(data){

        return axios.put('/user',data)
        .then(function (response) {
            // console.log("createCampaign then")
            return Promise.resolve(response)
        })
        .catch(function (error) {
            // console.log("createCampaign catch")
            return Promise.reject(error)
        });
    },
    deleteUser(id){
        return axios.delete('/user',
        {
            data: {
                "id": id,
            }
        })
        .then(function (response) {
            return Promise.resolve(response)
        })
        .catch(function (error) {
            return Promise.reject(error)
        });
    },
    getAllModule(){
        return axios.get('/user/get-all-module')
        .then(function (response) {
            return Promise.resolve(response)
        })
        .catch(function (error) {
            return Promise.reject(error)
        });
    },
    checkDuplicate(code)
    {
        return axios.get('/user/check-duplicate/'+code)
        .then(function (response) {
            return Promise.resolve(response)
        })
        .catch(function (error) {
            return Promise.reject(error)
        });  
    },
    getUserConfig() {
        return axios.get('/user?autocomp=true')
            .then(function(response) {
                return Promise.resolve(response);
            })
            .catch(function(error) {
                return Promise.reject(error);
            });
    },
    getUserApproval(datas) {
        var code = (datas && datas.code) ? datas.code : '';
        var boss_code = (datas && datas.boss_code) ? datas.boss_code : '';
        return axios.get('/user/approval/'+ code + '?boss_code=' + boss_code)
            .then(function(response) {
                return Promise.resolve(response.data);
            })
            .catch(function(error) {
                return Promise.reject(error);
            });
    },
    saveApproval(datas){
        var code = (datas && datas.code) ? datas.code : '';
        var dataselect = (datas && datas.select) ? datas.select : '';
        return axios.post('/user/approval/' + code, {select : dataselect})
            .then(function (response) {
                // console.log("createCampaign then")
                return Promise.resolve(response)
            })
            .catch(function (error) {
                // console.log("createCampaign catch")
                return Promise.reject(error)
            });
    },
    getUserUnder(code) {
        return axios.get('/user/under/'+ code)
            .then(function(response) {
                return Promise.resolve(response.data);
            })
            .catch(function(error) {
                return Promise.reject(error);
            });
    },
    saveViewPromo(datas){
        var code = (datas && datas.code) ? datas.code : '';
        var dataselect = (datas && datas.select) ? datas.select : '';
        return axios.post('/user/under/' + code, {select : dataselect})
            .then(function (response) {
                // console.log("createCampaign then")
                return Promise.resolve(response)
            })
            .catch(function (error) {
                // console.log("createCampaign catch")
                return Promise.reject(error)
            });
    },
}